// Modificaciones en marketplaceService.js
// Solo necesitamos pequeños ajustes para manejar el campo isOwnedByCurrentUser

import { api } from './config';
import API_CONFIG from './config';

const MARKETPLACE_BASE_URL = `${API_CONFIG.BASE_URL}/marketplace`;
const STATS_BASE_URL = `${API_CONFIG.BASE_URL}/stats`;

// Obtiene todos los productos publicados (puedes pasar excludeOwn para filtrar los tuyos)
export const getPublishedProducts = async (excludeOwn = false) => {
  try {
    console.log(`[DEBUG] Solicitando productos con excludeOwn=${excludeOwn}`);
    const response = await api.get(MARKETPLACE_BASE_URL, {
      params: { excludeOwn }
    });
    
    // Logging adicional para diagnóstico
    if (response.data && response.data.data) {
      console.log(`[DEBUG] Productos recibidos: ${response.data.data.length}`);
      console.log(`[DEBUG] Productos propios: ${
        response.data.data.filter(p => p.isOwnedByCurrentUser).length
      }`);
    }
    
    return response.data;
  } catch (error) {
    console.error('[DEBUG] Error en getPublishedProducts:', error);
    throw error;
  }
};

// Publica un producto en el marketplace
export const publishProduct = async (productId, productData) => {
  try {
    console.log(`[DEBUG] Publicando producto: ${productId}`);
    const response = await api.post(`${MARKETPLACE_BASE_URL}/publish/${productId}`, productData);
    return response.data;
  } catch (error) {
    console.error('[DEBUG] Error en publishProduct:', error);
    throw error;
  }
};

// Despublica un producto del marketplace
export const unpublishProduct = async (productId) => {
  try {
    console.log(`[DEBUG] Despublicando producto: ${productId}`);
    const response = await api.delete(`${MARKETPLACE_BASE_URL}/unpublish/${productId}`);
    return response.data;
  } catch (error) {
    console.error('[DEBUG] Error en unpublishProduct:', error);
    throw error;
  }
};

// Registra una nueva visualización de producto
export const recordProductView = async (productId) => {
  try {
    const response = await api.post(`${STATS_BASE_URL}/views`, {
      productId,
      timestamp: new Date().toISOString()
    });
    return response.data;
  } catch (error) {
    console.error('Error recording product view:', error);
    throw error;
  }
};

// Obtiene las estadísticas de visualizaciones de un producto
export const getProductViews = async (productId) => {
  try {
    const response = await api.get(`${STATS_BASE_URL}/views/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting product views:', error);
    throw error;
  }
};